import React, { useState, useEffect } from 'react';
import { FiMapPin, FiPhone, FiMail, FiClock, FiFacebook, FiInstagram, FiMessageCircle } from 'react-icons/fi';
import { FaTelegramPlane } from 'react-icons/fa';
import { toast } from 'react-hot-toast';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    
    // Simulate API call
    setTimeout(() => {
      toast.success('សាររបស់អ្នកត្រូវបានផ្ញើដោយជោគជ័យ!');
      setFormData({ name: '', email: '', phone: '', message: '' });
      setSubmitting(false);
    }, 1000);
  };

  const contactInfo = [
    {
      icon: FiMapPin,
      title: 'អាសយដ្ឋាន',
      details: [
        
        
        'ភ្នំពេញ, កម្ពុជា'
      ]
    },
    {
      icon: FiPhone,
      title: 'ទូរស័ព្ទ',
      details: [
        { number: '+855 10 612636', type: 'Smart / Cellcard' }
      ]
    },
    {
      icon: FiMail,
      title: 'អ៊ីមែល',
      details: ['grandfathersmile@gmail.com']
    },
    {
      icon: FiClock,
      title: 'ម៉ោងបើក',
      details: [
        'ចន្ទ - អាទិត្យ: ៨:០០ ព្រឹក - ៩:០០ យប់',
        'បើករាល់ថ្ងៃ',
        <span key="open-status" className="text-green-600 font-medium">✓ បើកដំណើរការរាល់ថ្ងៃ</span>
      ]
    }
  ];

  const socialLinks = [
    { icon: FiFacebook, url: 'https://web.facebook.com/GrandFatherSmile', label: 'Facebook', color: '#1877f2' },
    { icon: FiInstagram, url: 'https://instagram.com/grandfathersmile', label: 'Instagram', color: '#e4405f' },
    { icon: FaTelegramPlane, url: 'https://t.me/+85510612636', label: 'Telegram', color: '#0088cc' },
    { icon: FiMessageCircle, url: 'https://t.me/+85510612636', label: 'Messenger', color: '#00b2ff' }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      {/* Header */}
      <div className="text-center mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
          ទំនាក់ទំនង<span className="text-red-600">GrandFatherSmile</span>
        </h1>
        <p className="text-gray-600 text-sm max-w-2xl mx-auto">
          សូមទំនាក់ទំនងមកកាន់យើងខ្ញុំ តាមរយៈព័ត៌មានខាងក្រោម 
          ឬបំពេញទម្រង់ដើម្បីផ្ញើសារមកយើងខ្ញុំ
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Contact Information */}
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {contactInfo.map((info, index) => {
              const Icon = info.icon;
              return (
                <div key={index} className="bg-white border border-gray-200 p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <Icon size={24} className="text-red-600" />
                    <h3 className="font-semibold text-gray-800">{info.title}</h3>
                  </div>
                  <div className="space-y-1">
                    {info.details.map((detail, i) => (
                      <div key={i}>
                        {typeof detail === 'string' ? (
                          <p className="text-gray-600 text-sm">{detail}</p>
                        ) : detail.type ? (
                          <p className="text-gray-600 text-sm">
                            {detail.number} <span className="text-gray-400">({detail.type})</span>
                          </p>
                        ) : (
                          detail
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Social Media */}
          <div className="mt-5 bg-white border border-gray-200 p-5">
            <h3 className="font-semibold text-gray-800 mb-3">តាមដានយើង</h3>
            <div className="flex gap-3">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 border border-gray-200 text-gray-600 hover:border-red-600 hover:text-red-600 transition-colors"
                    title={social.label}
                  >
                    <Icon size={20} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Map */}
          <div className="mt-5 border border-gray-200 overflow-hidden rounded-lg">
            <iframe
              title="GrandFatherSmile Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d250151.16277613063!2d104.72537765410871!3d11.579654003275055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3109513dc76a6be3%3A0x9c010ee85ab525bb!2z4Z6X4Z-S4Z6T4Z-G4Z6W4Z-B4Z6J!5e0!3m2!1skm!2skh!4v1775927556885!5m2!1skm!2skh"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full"
            />
          </div>
        </div>

        {/* Contact Form */}
        <div className="bg-white border border-gray-200 p-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            ផ្ញើ<span className="text-red-600">សារមកយើង</span>
          </h2>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                ឈ្មោះ <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-200 bg-gray-50 text-gray-700 text-sm focus:outline-none focus:border-red-600 focus:bg-white transition-colors"
                placeholder="សូមបញ្ចូលឈ្មោះរបស់អ្នក"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                អ៊ីមែល <span className="text-red-600">*</span>
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-200 bg-gray-50 text-gray-700 text-sm focus:outline-none focus:border-red-600 focus:bg-white transition-colors"
                placeholder="សូមបញ្ចូលអ៊ីមែលរបស់អ្នក"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                លេខទូរស័ព្ទ
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-200 bg-gray-50 text-gray-700 text-sm focus:outline-none focus:border-red-600 focus:bg-white transition-colors"
                placeholder="សូមបញ្ចូលលេខទូរស័ព្ទ"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                សារ <span className="text-red-600">*</span>
              </label>
              <textarea
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-200 bg-gray-50 text-gray-700 text-sm focus:outline-none focus:border-red-600 focus:bg-white transition-colors"
                placeholder="សូមបញ្ចូលសាររបស់អ្នក..."
              />
            </div>

            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-red-600 text-white py-3 font-medium text-sm hover:bg-red-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              {submitting ? 'កំពុងផ្ញើ...' : 'ផ្ញើសារ'}
            </button>
          </form>

          <div className="mt-5 pt-4 border-t border-gray-200">
            <p className="text-xs text-gray-500 text-center">
              យើងនឹងឆ្លើយតបទៅកាន់អ្នកក្នុងរយៈពេល ២៤ ម៉ោង
            </p>
          </div>
        </div>
      </div>

      {/* Quick Contact Bar */}
      <div className="mt-8 bg-red-50 border border-red-200 p-4 rounded-lg">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <FiPhone className="text-red-600" size={24} />
            <div>
              <p className="text-sm font-medium text-gray-800">ទូរស័ព្ទលឿន</p>
              <p className="text-lg font-bold text-red-600">+855 10 612636</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <FaTelegramPlane className="text-red-600" size={24} />
            <div>
              <p className="text-sm font-medium text-gray-800">Telegram</p>
              <p className="text-sm text-gray-600">@GrandFatherSmile</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <FiClock className="text-red-600" size={24} />
            <div>
              <p className="text-sm font-medium text-gray-800">ម៉ោងបើក</p>
              <p className="text-sm text-gray-600">ចន្ទ - អាទិត្យ ៨:០០ - ២១:០០</p>
              <p className="text-xs text-green-600">បើករាល់ថ្ងៃ</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;